import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import 'preline/preline';
import './index.css';
import './i18n';
import { ReduxProvider } from '@core/providers/ReduxProvider';
import { router } from '@core/routing/router';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element #root not found');
}

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <ReduxProvider>
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
    </ReduxProvider>
  </React.StrictMode>,
);
